<template>
    <div>
        <title>Cancel</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">       
        <div class="cont">
            Cancel
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
    *{
        font-family: Roboto;
    }
    a{
        cursor: pointer;
    }
    .cont{
        width: 1188px;
        margin: 50px auto 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        padding: 57px 0 140px 0;
        @media only screen and (max-width: 1500px) {
            width: 95%;
        }            
        .nadpis{
            width: 474px;
            @media only screen and (max-width: 600px) {
                width: 90%;
                text-align: center;
            }
            margin: 0 auto 20px auto;
            text-align: center;
            font-style: normal;
            font-weight: bold;
            font-size: 24px;
            line-height: 28px;
            color: #000000;
        }
        .main{
            width: 1030px;
            margin: 0 auto;
            background: #F2F7FB;
            border-radius: 5px;
            padding: 30px 0 50px 0;
            margin-bottom: 50px;
            @media only screen and (max-width: 1500px) {
                width: 90%;
            }
        }
    }
</style>